import React from "react";

import styles from "../../../../styles/sort-categories-products.module.scss";

import { Button } from "../../../components/Button";
import { Drawer } from "../../../components/Drawer";
import { Hairline } from "../../../components/Hairline";
import { Message } from "../../../components/Message";
import SortItems from "../../../components/SortItems";

export default class SortCategories extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      reorderedCategories: [],
    };
  }

  async componentDidMount() {
    this.reorderedCategories = this.props.catalog.items;
  }

  render() {
    const { step } = this.state;

    const { open, close, setOpen, catalog, onSave } = this.props;

    const reorderCategories = (reorderedCategories) => {
      this.reorderedCategories = reorderedCategories;
    };

    const saveCatalog = async () => {
      const newCatalog = { ...catalog, items: this.reorderedCategories };
      onSave(newCatalog);
      setOpen(false);
    };

    const changeCatalogItemsToAlphabeticalOrder = async () => {
      catalog.items.sort((a, b) => a.name.localeCompare(b.name));
      this.reorderedCategories = catalog.items.map((item, i) => {
        return { ...item, position: i };
      });
      await saveCatalog();
    };

    return (
      <Drawer
        visible={open}
        onClose={() => setOpen(false)}
        title="Ordenar - Categorias"
        showBackButton={step === 2}
        backButton={() => this.setState({ step: 1 })}
        footer={
          step === 1 && (
            <Button design="primary" className="w-100" onClick={saveCatalog}>
              Aplicar
            </Button>
          )
        }
        withoutTransition
      >
        {step === 1 && (
          <>
            <div className="d-flex justify-center">
              <Button
                design="underline"
                onClick={() => this.setState({ step: 2 })}
              >
                VER ORDERNS PRÉ-DEFINIDAS
              </Button>
            </div>

            <Hairline />

            <div className={styles.categories}>
              <SortItems
                items={catalog.items}
                callback={(newOrder) => reorderCategories(newOrder)}
              />
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <div className="d-flex justify-between">
              <span className={styles.sortType}>Ordem alfabética</span>
              <Button
                design="underline"
                onClick={changeCatalogItemsToAlphabeticalOrder}
              >
                Aplicar
              </Button>
            </div>
            <Hairline />

            <Message>
              Você pode voltar ao modo manual para realizar uma alteração.
            </Message>
          </>
        )}
      </Drawer>
    );
  }
}
